module.exports = __webpack_public_path__ + "static/media/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.da03af28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg
// module id = 46
// module chunks = 0